// Components
import RoomInclusionsListComponent from './RoomInclusionslListComponent';
import CancelPolicyComponent from '@stencil/cancellation-policy-component/src/CancelPolicyComponent';
import RefundCancelFlow from './RefundCancelFlow';

//utils
import {nonNullable} from '@stencil/type-guards';
import {defaultTheme} from '@stencil/build-theme';

//icons
import HappyCloseIcon from '@stencil/icons/src/HappyCloseIcon/HappyCloseIcon';

//styles
import * as S from './PlanDetailsandPoliciesModal.styles';
import {BaseColumnWrap, SectionHeader} from '../../../../CommonStyleUtils/dwebCommon.styles';
import NonRefundableComponent from 'cancellation-policy-component/src/NonRefundanbleComponent';
import RatePlanInclusionUI from '../../RatePlanInclusionUI/RatePlanInclusionUI';

const noop = () => {};

const PlanDetailsPoliciesModal = ({roomData = {}, onCloseBtnClick = noop}) => {
  const {
    roomFlavorName,
    amenities = [],
    refundStatusText = '',
    cst = '',
    refundStatus,
    cancellationPolicyTimeline = {},
    isGetAwayDeal = false,
    ratePlanInclusionPersuation = [],
    roomTypeName,
    cancellationTimeline,
    cancellationPolicy,
    checkinDateDDMM,
    tariffPersuasion,
  } = roomData;

  return (
    <>
      <S.PlanTag>Plan Details & Policies</S.PlanTag>
      <S.RoomDetailsHeaderWrap>
        <BaseColumnWrap>
          <SectionHeader>{roomFlavorName}</SectionHeader>
          <S.Sub_header_para>{roomTypeName}</S.Sub_header_para>
        </BaseColumnWrap>
        <HappyCloseIcon
          height="2rem"
          width="2rem"
          fill={defaultTheme.colors.downriver.base}
          onClick={onCloseBtnClick}
        ></HappyCloseIcon>
      </S.RoomDetailsHeaderWrap>
      <S.RoomAmenitiesBodyWrap>
        {amenities?.length > 0 || isGetAwayDeal ? (
          <S.List_Container>
            <RoomInclusionsListComponent inclusions_list={amenities} />
            {tariffPersuasion?.roomInclusionPersuasion?.length ? (
              <div
                style={{
                  marginRight: '40px',
                  width: '50%',
                }}
              >
                <RatePlanInclusionUI
                  ratePlanInclusionData={tariffPersuasion?.roomInclusionPersuasion}
                  isMultiRoom={false}
                />
              </div>
            ) : null}

            {tariffPersuasion?.getawayDeals?.length ? (
              <div
                style={{
                  marginRight: '40px',
                  width: '50%',
                }}
              >
                <RatePlanInclusionUI
                  ratePlanInclusionData={tariffPersuasion?.getawayDeals}
                  isMultiRoom={false}
                />
              </div>
            ) : null}
          </S.List_Container>
        ) : null}

        <S.Cancel_Container>
          {cancellationPolicy?.type == 'NR' ? (
            <NonRefundableComponent data={cancellationPolicy} />
          ) : (
            <CancelPolicyComponent
              cancellationPolicyTimeline={cancellationPolicyTimeline}
              title={cancellationPolicyTimeline?.title}
              cancellationPolicy={cancellationPolicy}
              cancellationTimeline={cancellationTimeline}
            />
          )}
        </S.Cancel_Container>
      </S.RoomAmenitiesBodyWrap>
    </>
  );
};

export default PlanDetailsPoliciesModal;
